import React from "react";
import {
  VegaFlex,
  VegaFont,
  VegaIcon,
  VegaBox,
} from "@heartlandone/vega-react";
import dayjs from "dayjs";

function RegistrationTimeRange({ startTime, endTime }) {
  return (
    <VegaFlex gap={"size-12"} alignItems="center">
      <VegaBox width="size-16" height="size-16" style={{ textAlign: "center", lineHeight: '16px' }}>
        <VegaIcon
          size="size-16"
          icon="fal fa-hourglass"
          color="text-secondary"
        ></VegaIcon>
      </VegaBox>
      <VegaFont color="text-secondary" variant="font-field-value-sm">
        Registration Time: {dayjs(startTime).format("MM/DD/YYYY, HH:mm")} - {dayjs(endTime).format("MM/DD/YYYY, HH:mm")}
      </VegaFont>
    </VegaFlex>
  );
}

export default RegistrationTimeRange;
